module.exports = __webpack_public_path__ + "img/banner_1_zh.681fe235.png";